import { isNil } from 'es-toolkit';
import { DateTime } from 'luxon';

const CSV_FORMULA_TRIGGERS: readonly string[] = ['=', '+', '-', '@', '\t', '\r'];

export function csvCell(value: string): string {
  const trimmed = value.trimStart();
  const opensAFormula = CSV_FORMULA_TRIGGERS.some(
    (trigger) => value.startsWith(trigger) || trimmed.startsWith(trigger),
  );
  const guarded = opensAFormula && !Number.isFinite(Number(trimmed)) ? `'${value}` : value;
  return `"${guarded.replace(/"/g, '""')}"`;
}

export function csvValue(value: number | null): string {
  return isNil(value) ? '' : String(value);
}

export function csvDate(isoDateTime: string | null): string {
  if (isNil(isoDateTime)) {
    return '';
  }
  const parsed = DateTime.fromISO(isoDateTime);
  return parsed.isValid ? parsed.toFormat('yyyy-MM-dd') : '';
}
